import { useEffect } from 'react';

interface KeyboardListeners {
    [key: string]: () => any;
}

type ShouldBlock = () => boolean;

export const useKeyListener = (listeners: KeyboardListeners, shouldBlock: ShouldBlock) => {
    useEffect(() => {
        const handleKeyPress = (e: KeyboardEvent) => {
            if (Object.prototype.hasOwnProperty.call(listeners, e.key)) {
                if (shouldBlock()) {
                    e.preventDefault();
                }

                listeners[e.key]();
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [listeners]);
};
